import DualloAdminClient from "@/clients/duallo/DualloAdminClient";

class DualloAdminService {

    async getOrganizationsByTenant(){
        return await DualloAdminClient.getOrganizationsByTenant();
    }

    async getConnections(){
        return await DualloAdminClient.getConnectionsByTenant();
    }

    async createOrganization(request){
        return await DualloAdminClient.createOrganization(request)
    }

    async getScanSourceFilePath(organizationId, assetId, scanId){
        return await DualloAdminClient.getScanSourceFilePath(organizationId, assetId, scanId);
    }
    
    async getProcessedFileUploadSaSLink(organizationId, assetId, scanId, videoLength){
        return await DualloAdminClient.getProcessedFileUploadSaSLink(organizationId, assetId, scanId, videoLength);
    }

    async getModelFileUploadSaSLink(orgId, assetId, scanId){
        return await DualloAdminClient.getModelFileUploadSaSLink(orgId, assetId, scanId);
    }

    async getInternalsFileUploadSaSLink(orgId, assetId, scanId){
        return await DualloAdminClient.getInternalsFileUploadSaSLink(orgId, assetId, scanId);
    }

    async getExternalsFileUploadSaSLink(orgId, assetId, scanId){
        return await DualloAdminClient.getExternalsFileUploadSaSLink(orgId, assetId, scanId);
    }

    async getFramesFileUploadSaSLink(orgId, assetId, scanId, fileNames){
        return await DualloAdminClient.getFramesFileUploadSaSLink(orgId, assetId, scanId, fileNames);
    }

    async processFramesFiles(orgId, assetId, scanId){
        return await DualloAdminClient.processFramesFiles(orgId, assetId, scanId);
    }

    async getFileStatus(orgId, assetId, scanId){
        return await DualloAdminClient.getFileStatus(orgId, assetId, scanId);
    }

    async processCameraHelpers(orgId, assetId, scanId){
        return await DualloAdminClient.processCameraHelpers(orgId, assetId, scanId);
    }

    async setScanProcessingAsComplete(orgId, assetId, scanId){
        return await DualloAdminClient.setScanProcessingAsComplete(orgId, assetId, scanId);
    }

    async cancelScan(orgId, assetId, scanId, failureStage, reason){
        return await DualloAdminClient.cancelScan(orgId, assetId, scanId, failureStage, reason);
    }
}

export default new DualloAdminService();